import toastMessage from './toastMessage';

const setLocalStorageKeyPrefix = (key: string) => {
  const prefix = 'esc';
  return prefix + '-' + key;
};

const escConstants = {
  LOCAL_STORAGE_KEY: {
    accessKey: setLocalStorageKeyPrefix('access-token'),
    refreshKey: setLocalStorageKeyPrefix('refresh-token'),
    user: setLocalStorageKeyPrefix('user'),
    api: setLocalStorageKeyPrefix('api'),
    activeUser: setLocalStorageKeyPrefix('active-user'),
    socket: setLocalStorageKeyPrefix('socket'),
  },
  USER_ROLES: {
    client: 'CLIENT',
    admin: 'ADMIN',
    printer: 'PRINTER',
    technician: 'TECHNICIAN',
  } as const,
  ADMIN_DEPARTMENT: {
    root: 'ROOT',
    fireman: 'FIREMAN',
    draftsman: 'DRAFTSMAN',
  } as const,

  toastMessages: toastMessage,
};

export default escConstants;
